/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountControllerCloseAccountRepParams,
  AccountControllerCreateParams,
  AccountControllerGetMyAccountsParams,
  AccountControllerGetUserAccountsParams,
  AccountControllerListAccountsToTransferParams,
  AccountControllerUpdateAccountParams,
  AccountCreationResponse,
  AccountInfoResponse,
  AccountResponse,
  AccountWithRoleResponse,
  AddAccountRepRequest,
  BlockAccountRequest,
  ChangeRoleRequest,
  CreateAccountRequest,
  RevokeARInvitationRequest,
  SimpleAccountResponse,
  ToggleTrustedAccountRequest,
  UpdateAccountRequest
} from './sAFcBackend.schemas.js';

import accountControllerListAccountsToTransferMutator from '../response-type.js';
import accountControllerGetMutator from '../response-type.js';
import accountControllerUpdateAccountMutator from '../response-type.js';
import accountControllerUpdateTrustedRecipientMutator from '../response-type.js';
import accountControllerCreateMutator from '../response-type.js';
import accountControllerGetMyAccountsMutator from '../response-type.js';
import accountControllerGetUserAccountsMutator from '../response-type.js';
import accountControllerAddAccountRepMutator from '../response-type.js';
import accountControllerRevokeAccountRepInviteMutator from '../response-type.js';
import accountControllerCloseAccountMutator from '../response-type.js';
import accountControllerCloseAccountRepMutator from '../response-type.js';
import accountControllerChangeRoleMutator from '../response-type.js';
import accountControllerBlockAccountMutator from '../response-type.js';
import accountControllerUnblockAccountMutator from '../response-type.js';
import { customFormData } from '../mutators/custom-file-data.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const accountControllerListAccountsToTransfer = (
    params: AccountControllerListAccountsToTransferParams,
 options?: SecondParameter<typeof accountControllerListAccountsToTransferMutator>,signal?: AbortSignal
) => {


      return accountControllerListAccountsToTransferMutator<SimpleAccountResponse[]>(
      {url: `/api/account/to-transfer`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAccountControllerListAccountsToTransferQueryKey = (params?: AccountControllerListAccountsToTransferParams,) => {
    return [
    `/api/account/to-transfer`, ...(params ? [params] : [])
    ] as const;
    }


export const getAccountControllerListAccountsToTransferQueryOptions = <TData = Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError = unknown>(params: AccountControllerListAccountsToTransferParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError, TData>>, request?: SecondParameter<typeof accountControllerListAccountsToTransferMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountControllerListAccountsToTransferQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>> = ({ signal }) => accountControllerListAccountsToTransfer(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountControllerListAccountsToTransferQueryResult = NonNullable<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>>
export type AccountControllerListAccountsToTransferQueryError = unknown


export function useAccountControllerListAccountsToTransfer<TData = Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError = unknown>(
 params: AccountControllerListAccountsToTransferParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>,
          TError,
          Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerListAccountsToTransferMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerListAccountsToTransfer<TData = Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError = unknown>(
 params: AccountControllerListAccountsToTransferParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>,
          TError,
          Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerListAccountsToTransferMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerListAccountsToTransfer<TData = Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError = unknown>(
 params: AccountControllerListAccountsToTransferParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError, TData>>, request?: SecondParameter<typeof accountControllerListAccountsToTransferMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountControllerListAccountsToTransfer<TData = Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError = unknown>(
 params: AccountControllerListAccountsToTransferParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerListAccountsToTransfer>>, TError, TData>>, request?: SecondParameter<typeof accountControllerListAccountsToTransferMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountControllerListAccountsToTransferQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const accountControllerGet = (
    accountId: string,
 options?: SecondParameter<typeof accountControllerGetMutator>,signal?: AbortSignal
) => {


      return accountControllerGetMutator<AccountInfoResponse>(
      {url: `/api/account/${accountId}`, method: 'GET', signal
    },
      options);
    }




export const getAccountControllerGetQueryKey = (accountId: string,) => {
    return [
    `/api/account/${accountId}`
    ] as const;
    }


export const getAccountControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof accountControllerGet>>, TError = unknown>(accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGet>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountControllerGetQueryKey(accountId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountControllerGet>>> = ({ signal }) => accountControllerGet(accountId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: accountId !== null && accountId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof accountControllerGet>>>
export type AccountControllerGetQueryError = unknown


export function useAccountControllerGet<TData = Awaited<ReturnType<typeof accountControllerGet>>, TError = unknown>(
 accountId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerGet>>,
          TError,
          Awaited<ReturnType<typeof accountControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerGetMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerGet<TData = Awaited<ReturnType<typeof accountControllerGet>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerGet>>,
          TError,
          Awaited<ReturnType<typeof accountControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerGetMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerGet<TData = Awaited<ReturnType<typeof accountControllerGet>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGet>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountControllerGet<TData = Awaited<ReturnType<typeof accountControllerGet>>, TError = unknown>(
 accountId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGet>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountControllerGetQueryOptions(accountId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update account details
 */
export const accountControllerUpdateAccount = (
    accountId: string,
    updateAccountRequest: UpdateAccountRequest,
    params?: AccountControllerUpdateAccountParams,
 options?: SecondParameter<typeof accountControllerUpdateAccountMutator>,signal?: AbortSignal
) => {

      const formData = customFormData(updateAccountRequest)
      return accountControllerUpdateAccountMutator<void>(
      {url: `/api/account/${accountId}`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      options);
    }




export const getAccountControllerUpdateAccountMutationKey = () => ['accountControllerUpdateAccount'] as const;

export const getAccountControllerUpdateAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateAccount>>, TError,AccountControllerUpdateAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerUpdateAccountMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateAccount>>, TError,AccountControllerUpdateAccountMutationVariables, TContext> => {

const mutationKey = getAccountControllerUpdateAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerUpdateAccount>>, AccountControllerUpdateAccountMutationVariables> = (props) => {
          const {accountId,data,params} = props ?? {};

          return  accountControllerUpdateAccount(accountId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerUpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerUpdateAccount>>>
    export type AccountControllerUpdateAccountMutationBody = UpdateAccountRequest
    export type AccountControllerUpdateAccountMutationError = unknown
    export type AccountControllerUpdateAccountMutationVariables = {accountId: string;data: UpdateAccountRequest;params?: AccountControllerUpdateAccountParams}

    export const useAccountControllerUpdateAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateAccount>>, TError,AccountControllerUpdateAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerUpdateAccountMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerUpdateAccount>>,
        TError,
        AccountControllerUpdateAccountMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerUpdateAccountMutationOptions(options), queryClient);
    }
    /**
 * Update list of trusted recipients for account
 */
export const accountControllerUpdateTrustedRecipient = (
    accountId: string,
    toggleTrustedAccountRequest: ToggleTrustedAccountRequest,
 options?: SecondParameter<typeof accountControllerUpdateTrustedRecipientMutator>,signal?: AbortSignal
) => {


      return accountControllerUpdateTrustedRecipientMutator<void>(
      {url: `/api/account/${accountId}/trusted`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: toggleTrustedAccountRequest, signal
    },
      options);
    }




export const getAccountControllerUpdateTrustedRecipientMutationKey = () => ['accountControllerUpdateTrustedRecipient'] as const;

export const getAccountControllerUpdateTrustedRecipientMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateTrustedRecipient>>, TError,AccountControllerUpdateTrustedRecipientMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerUpdateTrustedRecipientMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateTrustedRecipient>>, TError,AccountControllerUpdateTrustedRecipientMutationVariables, TContext> => {

const mutationKey = getAccountControllerUpdateTrustedRecipientMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerUpdateTrustedRecipient>>, AccountControllerUpdateTrustedRecipientMutationVariables> = (props) => {
          const {accountId,data} = props ?? {};

          return  accountControllerUpdateTrustedRecipient(accountId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerUpdateTrustedRecipientMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerUpdateTrustedRecipient>>>
    export type AccountControllerUpdateTrustedRecipientMutationBody = ToggleTrustedAccountRequest
    export type AccountControllerUpdateTrustedRecipientMutationError = unknown
    export type AccountControllerUpdateTrustedRecipientMutationVariables = {accountId: string;data: ToggleTrustedAccountRequest}

    export const useAccountControllerUpdateTrustedRecipient = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUpdateTrustedRecipient>>, TError,AccountControllerUpdateTrustedRecipientMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerUpdateTrustedRecipientMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerUpdateTrustedRecipient>>,
        TError,
        AccountControllerUpdateTrustedRecipientMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerUpdateTrustedRecipientMutationOptions(options), queryClient);
    }
    /**
 * Create an account
 */
export const accountControllerCreate = (
    createAccountRequest: CreateAccountRequest,
    params: AccountControllerCreateParams,
 options?: SecondParameter<typeof accountControllerCreateMutator>,signal?: AbortSignal
) => {

      const formData = customFormData(createAccountRequest)
      return accountControllerCreateMutator<AccountCreationResponse>(
      {url: `/api/account`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params, signal
    },
      options);
    }




export const getAccountControllerCreateMutationKey = () => ['accountControllerCreate'] as const;

export const getAccountControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerCreate>>, TError,AccountControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerCreateMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerCreate>>, TError,AccountControllerCreateMutationVariables, TContext> => {

const mutationKey = getAccountControllerCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerCreate>>, AccountControllerCreateMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  accountControllerCreate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerCreate>>>
    export type AccountControllerCreateMutationBody = CreateAccountRequest
    export type AccountControllerCreateMutationError = unknown
    export type AccountControllerCreateMutationVariables = {data: CreateAccountRequest;params: AccountControllerCreateParams}

    export const useAccountControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerCreate>>, TError,AccountControllerCreateMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerCreateMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerCreate>>,
        TError,
        AccountControllerCreateMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerCreateMutationOptions(options), queryClient);
    }
    export const accountControllerGetMyAccounts = (
    params?: AccountControllerGetMyAccountsParams,
 options?: SecondParameter<typeof accountControllerGetMyAccountsMutator>,signal?: AbortSignal
) => {


      return accountControllerGetMyAccountsMutator<AccountResponse[]>(
      {url: `/api/account`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAccountControllerGetMyAccountsQueryKey = (params?: AccountControllerGetMyAccountsParams,) => {
    return [
    `/api/account`, ...(params ? [params] : [])
    ] as const;
    }


export const getAccountControllerGetMyAccountsQueryOptions = <TData = Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError = unknown>(params?: AccountControllerGetMyAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetMyAccountsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountControllerGetMyAccountsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>> = ({ signal }) => accountControllerGetMyAccounts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountControllerGetMyAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>>
export type AccountControllerGetMyAccountsQueryError = unknown


export function useAccountControllerGetMyAccounts<TData = Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError = unknown>(
 params: undefined |  AccountControllerGetMyAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerGetMyAccounts>>,
          TError,
          Awaited<ReturnType<typeof accountControllerGetMyAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerGetMyAccountsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerGetMyAccounts<TData = Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError = unknown>(
 params?: AccountControllerGetMyAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerGetMyAccounts>>,
          TError,
          Awaited<ReturnType<typeof accountControllerGetMyAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerGetMyAccountsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerGetMyAccounts<TData = Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError = unknown>(
 params?: AccountControllerGetMyAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetMyAccountsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountControllerGetMyAccounts<TData = Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError = unknown>(
 params?: AccountControllerGetMyAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetMyAccounts>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetMyAccountsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountControllerGetMyAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const accountControllerGetUserAccounts = (
    userId: string,
    params: AccountControllerGetUserAccountsParams,
 options?: SecondParameter<typeof accountControllerGetUserAccountsMutator>,signal?: AbortSignal
) => {


      return accountControllerGetUserAccountsMutator<AccountWithRoleResponse[]>(
      {url: `/api/account/by-user/${userId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAccountControllerGetUserAccountsQueryKey = (userId: string,
    params?: AccountControllerGetUserAccountsParams,) => {
    return [
    `/api/account/by-user/${userId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getAccountControllerGetUserAccountsQueryOptions = <TData = Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError = unknown>(userId: string,
    params: AccountControllerGetUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetUserAccountsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountControllerGetUserAccountsQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>> = ({ signal }) => accountControllerGetUserAccounts(userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountControllerGetUserAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>>
export type AccountControllerGetUserAccountsQueryError = unknown


export function useAccountControllerGetUserAccounts<TData = Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError = unknown>(
 userId: string,
    params: AccountControllerGetUserAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerGetUserAccounts>>,
          TError,
          Awaited<ReturnType<typeof accountControllerGetUserAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerGetUserAccountsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerGetUserAccounts<TData = Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError = unknown>(
 userId: string,
    params: AccountControllerGetUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountControllerGetUserAccounts>>,
          TError,
          Awaited<ReturnType<typeof accountControllerGetUserAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accountControllerGetUserAccountsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountControllerGetUserAccounts<TData = Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError = unknown>(
 userId: string,
    params: AccountControllerGetUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetUserAccountsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountControllerGetUserAccounts<TData = Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError = unknown>(
 userId: string,
    params: AccountControllerGetUserAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetUserAccounts>>, TError, TData>>, request?: SecondParameter<typeof accountControllerGetUserAccountsMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountControllerGetUserAccountsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create invitation to become given account's representative
 */
export const accountControllerAddAccountRep = (
    id: string,
    addAccountRepRequest: AddAccountRepRequest,
 options?: SecondParameter<typeof accountControllerAddAccountRepMutator>,signal?: AbortSignal
) => {


      return accountControllerAddAccountRepMutator<void>(
      {url: `/api/account/${id}/account-rep`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAccountRepRequest, signal
    },
      options);
    }




export const getAccountControllerAddAccountRepMutationKey = () => ['accountControllerAddAccountRep'] as const;

export const getAccountControllerAddAccountRepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerAddAccountRep>>, TError,AccountControllerAddAccountRepMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerAddAccountRepMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerAddAccountRep>>, TError,AccountControllerAddAccountRepMutationVariables, TContext> => {

const mutationKey = getAccountControllerAddAccountRepMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerAddAccountRep>>, AccountControllerAddAccountRepMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  accountControllerAddAccountRep(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerAddAccountRepMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerAddAccountRep>>>
    export type AccountControllerAddAccountRepMutationBody = AddAccountRepRequest
    export type AccountControllerAddAccountRepMutationError = unknown
    export type AccountControllerAddAccountRepMutationVariables = {id: string;data: AddAccountRepRequest}

    export const useAccountControllerAddAccountRep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerAddAccountRep>>, TError,AccountControllerAddAccountRepMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerAddAccountRepMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerAddAccountRep>>,
        TError,
        AccountControllerAddAccountRepMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerAddAccountRepMutationOptions(options), queryClient);
    }
    /**
 * Revoke invitation to given account
 */
export const accountControllerRevokeAccountRepInvite = (
    id: string,
    revokeARInvitationRequest: RevokeARInvitationRequest,
 options?: SecondParameter<typeof accountControllerRevokeAccountRepInviteMutator>,signal?: AbortSignal
) => {


      return accountControllerRevokeAccountRepInviteMutator<void>(
      {url: `/api/account/${id}/revoke-invitation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: revokeARInvitationRequest, signal
    },
      options);
    }




export const getAccountControllerRevokeAccountRepInviteMutationKey = () => ['accountControllerRevokeAccountRepInvite'] as const;

export const getAccountControllerRevokeAccountRepInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerRevokeAccountRepInvite>>, TError,AccountControllerRevokeAccountRepInviteMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerRevokeAccountRepInviteMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerRevokeAccountRepInvite>>, TError,AccountControllerRevokeAccountRepInviteMutationVariables, TContext> => {

const mutationKey = getAccountControllerRevokeAccountRepInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerRevokeAccountRepInvite>>, AccountControllerRevokeAccountRepInviteMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  accountControllerRevokeAccountRepInvite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerRevokeAccountRepInviteMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerRevokeAccountRepInvite>>>
    export type AccountControllerRevokeAccountRepInviteMutationBody = RevokeARInvitationRequest
    export type AccountControllerRevokeAccountRepInviteMutationError = unknown
    export type AccountControllerRevokeAccountRepInviteMutationVariables = {id: string;data: RevokeARInvitationRequest}

    export const useAccountControllerRevokeAccountRepInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerRevokeAccountRepInvite>>, TError,AccountControllerRevokeAccountRepInviteMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerRevokeAccountRepInviteMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerRevokeAccountRepInvite>>,
        TError,
        AccountControllerRevokeAccountRepInviteMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerRevokeAccountRepInviteMutationOptions(options), queryClient);
    }
    /**
 * Close an account
 */
export const accountControllerCloseAccount = (
    id: string,
 options?: SecondParameter<typeof accountControllerCloseAccountMutator>,signal?: AbortSignal
) => {


      return accountControllerCloseAccountMutator<void>(
      {url: `/api/account/${id}/close`, method: 'POST', signal
    },
      options);
    }




export const getAccountControllerCloseAccountMutationKey = () => ['accountControllerCloseAccount'] as const;

export const getAccountControllerCloseAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerCloseAccount>>, TError,AccountControllerCloseAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerCloseAccountMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerCloseAccount>>, TError,AccountControllerCloseAccountMutationVariables, TContext> => {

const mutationKey = getAccountControllerCloseAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerCloseAccount>>, AccountControllerCloseAccountMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  accountControllerCloseAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerCloseAccountMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerCloseAccount>>>

    export type AccountControllerCloseAccountMutationError = unknown
    export type AccountControllerCloseAccountMutationVariables = {id: string}

    export const useAccountControllerCloseAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerCloseAccount>>, TError,AccountControllerCloseAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerCloseAccountMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerCloseAccount>>,
        TError,
        AccountControllerCloseAccountMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerCloseAccountMutationOptions(options), queryClient);
    }
    /**
 * Remove account representative from account
 */
export const accountControllerCloseAccountRep = (
    id: string,
    accountRepresentativeId: string,
    params?: AccountControllerCloseAccountRepParams,
 options?: SecondParameter<typeof accountControllerCloseAccountRepMutator>,signal?: AbortSignal
) => {


      return accountControllerCloseAccountRepMutator<void>(
      {url: `/api/account/${id}/account-rep/${accountRepresentativeId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getAccountControllerCloseAccountRepMutationKey = () => ['accountControllerCloseAccountRep'] as const;

export const getAccountControllerCloseAccountRepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerCloseAccountRep>>, TError,AccountControllerCloseAccountRepMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerCloseAccountRepMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerCloseAccountRep>>, TError,AccountControllerCloseAccountRepMutationVariables, TContext> => {

const mutationKey = getAccountControllerCloseAccountRepMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerCloseAccountRep>>, AccountControllerCloseAccountRepMutationVariables> = (props) => {
          const {id,accountRepresentativeId,params} = props ?? {};

          return  accountControllerCloseAccountRep(id,accountRepresentativeId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerCloseAccountRepMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerCloseAccountRep>>>

    export type AccountControllerCloseAccountRepMutationError = unknown
    export type AccountControllerCloseAccountRepMutationVariables = {id: string;accountRepresentativeId: string;params?: AccountControllerCloseAccountRepParams}

    export const useAccountControllerCloseAccountRep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerCloseAccountRep>>, TError,AccountControllerCloseAccountRepMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerCloseAccountRepMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerCloseAccountRep>>,
        TError,
        AccountControllerCloseAccountRepMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerCloseAccountRepMutationOptions(options), queryClient);
    }
    /**
 * Update account representative role
 */
export const accountControllerChangeRole = (
    id: string,
    userId: string,
    changeRoleRequest: ChangeRoleRequest,
 options?: SecondParameter<typeof accountControllerChangeRoleMutator>,signal?: AbortSignal
) => {


      return accountControllerChangeRoleMutator<void>(
      {url: `/api/account/${id}/account-rep/${userId}/role`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeRoleRequest, signal
    },
      options);
    }




export const getAccountControllerChangeRoleMutationKey = () => ['accountControllerChangeRole'] as const;

export const getAccountControllerChangeRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerChangeRole>>, TError,AccountControllerChangeRoleMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerChangeRoleMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerChangeRole>>, TError,AccountControllerChangeRoleMutationVariables, TContext> => {

const mutationKey = getAccountControllerChangeRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerChangeRole>>, AccountControllerChangeRoleMutationVariables> = (props) => {
          const {id,userId,data} = props ?? {};

          return  accountControllerChangeRole(id,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerChangeRoleMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerChangeRole>>>
    export type AccountControllerChangeRoleMutationBody = ChangeRoleRequest
    export type AccountControllerChangeRoleMutationError = unknown
    export type AccountControllerChangeRoleMutationVariables = {id: string;userId: string;data: ChangeRoleRequest}

    export const useAccountControllerChangeRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerChangeRole>>, TError,AccountControllerChangeRoleMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerChangeRoleMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerChangeRole>>,
        TError,
        AccountControllerChangeRoleMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerChangeRoleMutationOptions(options), queryClient);
    }
    /**
 * Block an account
 */
export const accountControllerBlockAccount = (
    accountId: string,
    blockAccountRequest: BlockAccountRequest,
 options?: SecondParameter<typeof accountControllerBlockAccountMutator>,signal?: AbortSignal
) => {


      return accountControllerBlockAccountMutator<void>(
      {url: `/api/account/${accountId}/block`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: blockAccountRequest, signal
    },
      options);
    }




export const getAccountControllerBlockAccountMutationKey = () => ['accountControllerBlockAccount'] as const;

export const getAccountControllerBlockAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerBlockAccount>>, TError,AccountControllerBlockAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerBlockAccountMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerBlockAccount>>, TError,AccountControllerBlockAccountMutationVariables, TContext> => {

const mutationKey = getAccountControllerBlockAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerBlockAccount>>, AccountControllerBlockAccountMutationVariables> = (props) => {
          const {accountId,data} = props ?? {};

          return  accountControllerBlockAccount(accountId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerBlockAccountMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerBlockAccount>>>
    export type AccountControllerBlockAccountMutationBody = BlockAccountRequest
    export type AccountControllerBlockAccountMutationError = unknown
    export type AccountControllerBlockAccountMutationVariables = {accountId: string;data: BlockAccountRequest}

    export const useAccountControllerBlockAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerBlockAccount>>, TError,AccountControllerBlockAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerBlockAccountMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerBlockAccount>>,
        TError,
        AccountControllerBlockAccountMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerBlockAccountMutationOptions(options), queryClient);
    }
    /**
 * Unblock an account
 */
export const accountControllerUnblockAccount = (
    accountId: string,
 options?: SecondParameter<typeof accountControllerUnblockAccountMutator>,signal?: AbortSignal
) => {


      return accountControllerUnblockAccountMutator<void>(
      {url: `/api/account/${accountId}/unblock`, method: 'PATCH', signal
    },
      options);
    }




export const getAccountControllerUnblockAccountMutationKey = () => ['accountControllerUnblockAccount'] as const;

export const getAccountControllerUnblockAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUnblockAccount>>, TError,AccountControllerUnblockAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerUnblockAccountMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accountControllerUnblockAccount>>, TError,AccountControllerUnblockAccountMutationVariables, TContext> => {

const mutationKey = getAccountControllerUnblockAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerUnblockAccount>>, AccountControllerUnblockAccountMutationVariables> = (props) => {
          const {accountId} = props ?? {};

          return  accountControllerUnblockAccount(accountId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccountControllerUnblockAccountMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerUnblockAccount>>>

    export type AccountControllerUnblockAccountMutationError = unknown
    export type AccountControllerUnblockAccountMutationVariables = {accountId: string}

    export const useAccountControllerUnblockAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerUnblockAccount>>, TError,AccountControllerUnblockAccountMutationVariables, TContext>, request?: SecondParameter<typeof accountControllerUnblockAccountMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountControllerUnblockAccount>>,
        TError,
        AccountControllerUnblockAccountMutationVariables,
        TContext
      > => {
      return useMutation(getAccountControllerUnblockAccountMutationOptions(options), queryClient);
    }
